import React, { useEffect, useRef, useState } from 'react';
import { useUser } from '../../../auth/UseUser';
import MDEditor from '@uiw/react-md-editor';
import '../../../style/pitanje-card.css';
import { ReactComponent as ConfirmIcon } from '../../../assets/svg/ConfirmIcon.svg';
import Slideshow from './Slideshow';
import { MarkDownView } from '../../common/MarkDownView';

function PitanjeCard({ pitanje, scrollViewRef, index, showBroj = false }: { pitanje: any; scrollViewRef?: any; index: number; showBroj?: boolean }) {
    const { showSelectedPuskica, selectedPitanje, setSelectedPitanje, selectedPitanja, setSelectedPitanja } = useUser();

    const slideIndex = useRef(1);

    const isSelected = () => {
        const index = selectedPitanja.findIndex((e: any) => e.id === pitanje.id);
        if (index === -1) return false;
        else return true;
    };

    const handleSelectPitanje = (pitanje: any) => {
        const index = selectedPitanja.findIndex((e: any) => e.id === pitanje.id);
        if (index === -1) {
            //console.log('dodajem', selectedQuickTipsList);
            setSelectedPitanja([...selectedPitanja, { ...pitanje, redosled: selectedPitanja.length + 1 }]);
        } else {
            //console.log('uklanjam', selectedQuickTipsList);
            const newList = selectedPitanja.filter((e: any) => e.id !== pitanje.id);
            //console.log('uklanjam i setujem', newList);
            setSelectedPitanja(newList);
        }
    };

    return (
        <div
            className="border-b border-b-greyMedium pb-5 mb-5"
            ref={selectedPitanje?.id === pitanje?.id ? scrollViewRef : undefined}
            onClick={() => setSelectedPitanje(pitanje)}
            id={`moja-komponenta-${index}`}
        >
            <div className="flex flex-col md:flex-row justify-between gap-2 md:gap-5">
                <div className="flex flex-row gap-5">
                    {showSelectedPuskica && (
                        <div
                            className=""
                            onClick={(e: any) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleSelectPitanje(pitanje);
                            }}
                        >
                            <div
                                className={`w-5 h-5 rounded-[4px] flex items-center justify-center cursor-pointer  border border-primaryViolet ${isSelected() ? 'bg-schoolBoardLight' : 'bg-white'}`}
                            >
                                {isSelected() && <ConfirmIcon />}
                            </div>
                        </div>
                    )}
                    <div className="flex flex-row  gap-2">
                        {showBroj && <p className="text-[16px] text-beeBlack leading-5 font-bold">{index + 1}.</p>}
                        <MarkDownView
                            style={{ textAlign: 'left', backgroundColor: 'transparent', fontSize: 18, fontWeight: 700, color: '#2e7d32' }}
                            source={pitanje?.naziv}
                        />
                    </div>
                </div>
            </div>
            <div className="flex flex-col-reverse md:flex-row gap-4 mt-4">
                <div className="flex-1 pitanje-odgovor">
                    <MarkDownView style={{ textAlign: 'left', backgroundColor: 'transparent', fontWeight: 400, whiteSpace: 'normal' }} source={pitanje?.odgovor} zoomImages />
                </div>
                {pitanje.oblastImages && pitanje.oblastImages?.length !== 0 && <Slideshow images={pitanje.oblastImages} width={335} height={250} />}
            </div>
        </div>
    );
}

export default PitanjeCard;
